import { gql } from '@apollo/client';
import { PROGRAMME } from '../fragments';

export const ALL_INSTITUTION_PROGRAMMES = gql`
  query AllInstitutionProgrammes($input: FilterArgs) {
    programmes: institutionProgrammes(input: $input) {
      ...programme
      geographies {
        id
        name
      }
      reportersCount
      theoryOfChangeFile {
        id
        name
        url
      }
    }
  }
  ${PROGRAMME}
`;
